<template>
  <inventoryProductsSubCategoriesForm :typeEndPoint="'papeleriaProductsSubCategoriesForm'" :dataParams="{}" />
</template>
<script>
import inventoryProductsSubCategoriesForm from '@/components/modules/papeleria/products/subcategories/form'
export default {
  name: 'inventoryProductsSubCategories',
  components: {
    inventoryProductsSubCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}

</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/subcategories/create.vue